export const TENANT_PERMISSIONS = [
  {
    // auth
    'display-activation-request': ['oval'],
    'display-terms-of-service': ['oval', 'torus', 'symmetral', 'ift'],
    'display-auth-image': ['oval', 'torus', 'tma', 'ift'],
    // dashboard
    'display-dashboard-exchange-rates': ['oval', 'torus'],
    'display-dashboard-see-accounts-button': ['oval', 'torus'],
    'display-dashboard-request-account-button': ['oval', 'torus', 'symmetral'],
    'display-dashboard-ongoing-transactions-icon': ['tma'],
    'dashboard-receive-payment-button-action': ['oval', 'torus', 'ift'],
    'display-coming-soon-drawer': ['oval', 'torus'],
    'display-ongoing-bulk-payout': ['tma', 'ift'],
    // external api
    'display-yield-offering': ['oval'],
    'api-treasury-access': ['oval'],
    // side nav
    'terminal-access': ['oval', 'torus'],
    'exchange-rates-access': ['oval', 'torus'],
    'payment-link-access': ['oval', 'torus', 'tma', 'symmetral', 'ift'],
    'virtual-cards-access': ['oval', 'torus'],
    'withdrawal-access': ['oval', 'torus', 'tma', 'symmetral', 'ift'],
    'bridge-access': ['oval'],
    'display-footer': ['oval', 'torus'],
    'payout-access': ['oval', 'torus', 'tma', 'ift'],
    'bottom-settings': ['tma', 'symmetral', 'ift'],
    // settings
    'contract-access': ['oval', 'torus'],
    'asset-access': ['oval'],
    'api-access': ['oval', 'torus'],
    // deposit
    'multiple-currency-deposit-access': ['oval', 'torus', 'symmetral'],
    'display-ongoing-transaction': ['oval', 'torus', 'tma', 'ift'],
    // footer
    'display-twitter-link': ['torus'],
    'display-medium-link': ['oval'],

    'use-currency-short': ['symmetral'],
    'asset-details-bar': ['symmetral']
  }
]
